import Swiper from 'swiper';

/**
 *
 * Slider
 *
 */

var imageSlider = new Swiper('.image-slider', {
  loop: true,
  parallax: true,
  simulateTouch: false,

  // preloadImages: false,
  // lazy: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },

  a11y: {
    prevSlideMessage: window.prevSlideText,
    nextSlideMessage: window.nextSlideText,
    paginationBulletMessage: window.paginationBulletText + ' {{index}}',
  },

});

// Image slider accessability
jQuery(document).ready(function() {
  jQuery('.image-slider .swiper-pagination-bullet').attr("aria-expanded", "false");
  jQuery('.image-slider .swiper-pagination-bullet-active').attr("aria-expanded", "true");
});

imageSlider.on('slideChange', function () {
  jQuery('.image-slider .swiper-pagination-bullet').attr("aria-expanded", "false");
  jQuery('.image-slider .swiper-pagination-bullet-active').attr("aria-expanded", "true");
});


var itemSlider = new Swiper('.item-slider', {

slidesPerView: 4,
spaceBetween: 30,

// preloadImages: false,
// lazy: {
//   loadPrevNext: true,
// },

navigation: {
  nextEl: '.button-next',
  prevEl: '.button-prev',
},
breakpoints: {
  1024: {
    slidesPerView: 3,
    spaceBetween: 32,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 16,
  },
  640: {
    slidesPerView: 1,
    spaceBetween: 16,
  }
},

a11y: {
  prevSlideMessage: window.prevSlideText,
  nextSlideMessage: window.nextSlideText,
},

});


var someSlider = new Swiper('.some-slider', {

  slidesPerView: 3,
  spaceBetween: 32,

  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },
  breakpoints: {
    1024: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 16,
    }
  },

  a11y: {
    prevSlideMessage: window.prevSlideText,
    nextSlideMessage: window.nextSlideText,
  },

  });
